/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,e=null){this.labelText=e,this.elevationOffset=t??0}}export{t as Graphics3DObjectMetadata};
